import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fieldModalTitle'
})
export class FieldModalTitlePipe implements PipeTransform {
  transform(value: string, modalData?: any): any {
    return `${modalData ? 'Edit' : 'Add'} ${value} field`;
  }
}
